import {API} from '@aws-amplify/api'
import {Auth} from '@aws-amplify/auth'
import {IntercomBrowserClient} from '@peachy/intercom-browser-client'
import {useRef} from 'react'

export default function useIntercom() {
    const intercomInterface = useRef(new IntercomBrowserClient(API, Auth))
    return intercomInterface.current
}
